<template>
    <b-overlay :show="item.is_loading" rounded="sm">
        <a
            class="waves-effect waves-themed pl-1 pr-1"
            @click.prevent="$emit('edit', item)"
        >
            <!-- чекбокс и кликабельная зона -->
            <div class="loc_click p-2" @click.stop.prevent="$emit('toggle', item)">
                <b-form-checkbox
                    :name="'loc_' + item.id"
                    :id="'loc_' + item.id"
                    v-model="item.is_checked"
                />
            </div>

            <!-- основная информация -->
            <div class="nav-link-text color-black d-block">
                <div>
                    {{ item.title }}
                    <sup>
                        <span class="badge badge-warning ml-2">
                          {{ item.uniq_id }}
                        </span>
                    </sup>
                    <sup v-if="hasDelivery">
                        <span class="badge badge-info ml-2">
                          {{ __t('AUTO_DELIVERY') }}
                        </span>
                    </sup>
                </div>
                <div class="small" v-if="item.linked_restaurant">
                    LINK_REST: {{ item.linked_restaurant.address }} |
                    {{ item.linked_restaurant.title }}
                </div>
                <base_location_status :cur_location="item" />
            </div>

            <!-- кнопки действий -->
            <div class="buttons">
                <button
                    class="btn btn-icon btn-sm btn-danger rounded-circle waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('remove', item)"
                >
                    <i class="fal fa-trash"></i>
                </button>

                <button
                    v-if="hasBusyMode"
                    class="btn btn-icon btn-sm btn-success waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('busy-on', item)"
                >
                    <i class="fal fa-business-time"></i>
                </button>

                <button
                    v-if="hasOnline"
                    class="btn btn-icon btn-sm btn-success waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('online', item)"
                >
                    <i class="fal fa-play"></i>
                </button>
                <button
                    v-if="hasOffline"
                    class="btn btn-icon btn-sm btn-info waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('offline', item)"
                >
                    <i class="fal fa-stopwatch"></i>
                </button>

                <button
                    v-if="hasJson"
                    class="btn btn-icon btn-sm btn-warning rounded-circle waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('json', item)"
                >
                    <i class="fal fa-building"></i>
                </button>
                <button
                    v-if="hasPreview"
                    class="btn btn-icon btn-sm btn-warning rounded-circle waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('preview', item)"
                >
                    <i class="fal fa-eye"></i>
                </button>

                <button
                    v-if="hasSync"
                    class="btn btn-icon btn-sm btn-success rounded-circle waves-effect waves-themed ml-2 mr-2"
                    @click.prevent.stop="$emit('sync', item)"
                >
                    <i class="fal fa-sync"></i>
                </button>
                <button
                    v-if="hasSyncUpdate"
                    class="btn btn-icon btn-sm btn-warning rounded-circle waves-effect waves-themed ml-2"
                    @click.prevent.stop="$emit('sync-update', item)"
                >
                    <i class="fal fa-sync"></i>
                </button>
            </div>
        </a>
    </b-overlay>
</template>

<script>
import base_location_status from "../location_status/base_location_status.vue";
export default {
    name: "LocationItem",
    components: { base_location_status },
    props: {
        item: { type: Object, required: true },
        hasOnline:  Boolean,
        hasOffline: Boolean,
        hasSync:    Boolean,
        hasSyncUpdate: Boolean,
        hasJson:    Boolean,
        hasPreview: Boolean,
        hasBusyMode:Boolean,
    },
    computed: {
        hasDelivery() {
            return !!(this.item.delivery_auto && this.item.delivery_auto.id);
        }
    }
};
</script>
